import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs/index';
import { Material, Order, Size } from './order.model';
import { UIService } from '../shared/ui.service';
import { environment } from '../../environments/environment';
import { StorageService } from '../storage/storage.service';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/internal/operators';
import { Reservation } from '../reservation/reservation.model';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  currentProject: number;

  constructor(
    private http: HttpClient,
    private uiService: UIService,
    private ngZone: NgZone,
    private storageService: StorageService,
  ) { }

  getOrders(token): Observable<Order[]> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = {};
    const url = environment.APIEndpoint + 'client-api/reservations/';
    return this.http.get<[Order]>(url, {
      headers: headers
    });
  }

  getOrderById(token, orderId): Observable<Order> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = {};
    const url = environment.APIEndpoint + `client-api/reservations/${orderId}/`;
    return this.http.get<Order>(url, {
      headers: headers
    });
  }

  getOrdersByIdV2(token, orderId): Observable<Order> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);

    this.currentProject = this.storageService.getPreferredProject();

    const body = {};

    if (this.currentProject !== null){
      body['project'] = this.currentProject.toString();
    }

    const url = environment.APIEndpoint + `orders/${orderId}/`;
    return this.http.get<Order>(url, {
      headers: headers,
      params: body
    });
  }

  getInvoicePDF(token, invoice): Observable<any> {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);

    const body = {};


    const url = environment.APIEndpoint + 'invoices/' + invoice.id + '/pdf/';
    const options = {
      headers: headers,
      params: body,
      responseType: 'blob' as 'json'
    }

    return this.http.get<any>(url, options).pipe(
      map((result: HttpResponse<Blob>) => {
        console.log(result);
        const blob = result;
        const fileURL = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = invoice.id + '-' + invoice.quickbook_sale_receipt_id + '-invoice.pdf';
        document.body.appendChild(a);
        a.click();
        return result;
      }));
  }

  getOrdersWithV2Invoices(token): Observable<Order[]> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    this.currentProject = this.storageService.getPreferredProject();

    const body = {};

    if (this.currentProject !== null){
      body['project'] = this.currentProject.toString();
    }
    const url = environment.APIEndpoint + 'client-api/v2/invoices/';
    return this.http.get<[Order]>(url, {
      headers: headers,
      params: body
    });
  }

  getMaterials(token): Observable<Material[]> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = {};
    const url = environment.APIEndpoint + 'client-api/materials/';
    return this.http.get<[Material]>(url, {
      headers: headers
    });
  }

  getBinsizes(token): Observable<Size[]> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = {};
    const url = environment.APIEndpoint + 'client-api/sizes/';
    return this.http.get<[Size]>(url, {
      headers: headers
    });
  }

  getDeliveryOrders(token): Observable<Order[]> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = {};
    const url = environment.APIEndpoint + 'client-api/delivery/';
    return this.http.get<[Order]>(url, {
      headers: headers
    });
  }

  getDeliveryOrderById(token, orderId): Observable<Order> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = {};
    const url = environment.APIEndpoint + `client-api/delivery/${orderId}/`;
    return this.http.get<Order>(url, {
      headers: headers
    });
  }

  getOnSiteOrders(token): Observable<Order[]> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = {};
    const url = environment.APIEndpoint + 'client-api/on-site/';
    return this.http.get<[Order]>(url, {
      headers: headers
    });
  }

  getOnSiteOrderById(token, orderId): Observable<Order> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = {};
    const url = environment.APIEndpoint + `client-api/on-site/${orderId}/`;
    return this.http.get<Order>(url, {
      headers: headers
    });
  }

  getPickupOrders(token): Observable<Order[]> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = {};
    const url = environment.APIEndpoint + 'client-api/pickup/';
    return this.http.get<[Order]>(url, {
      headers: headers
    });
  }

  getPickupOrderById(token, orderId): Observable<Order> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = {};
    const url = environment.APIEndpoint + `client-api/pickup/${orderId}/`;
    return this.http.get<Order>(url, {
      headers: headers
    });
  }

  setOrderReadyForPickup(token, order_id): Observable<Order> {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = {};
    const url = environment.APIEndpoint + `client-api/on-site/${order_id}/ready-for-pickup/`;
    return this.http.put<Order>(url, {},{
      headers: headers
    });
  }

  setOrderForSwitch(token, order_id, reservation: Reservation): Observable<Order> {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = reservation;
    const url = environment.APIEndpoint + `client-api/on-site/${order_id}/set-for-switch/`;
    return this.http.put<Order>(url, body,{
      headers: headers
    });
  }

 /*
  createOrder(token, order: OrderReservation): Observable<OrderReservation> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = order;
    const url = environment.APIEndpoint + 'client-api/reservations/';
    return this.http.post<OrderReservation>(url, body, {
      headers: headers
    });
  }

  updateOrder(token, order: OrderReservation): Observable<OrderReservation> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = order;
    const url = environment.APIEndpoint + `client-api/reservations/${order.id}/`;
    return this.http.put<OrderReservation>(url, body, {
      headers: headers
    });
  }
*/

}
